import React from 'react';
import Lozenge from '@atlaskit/lozenge';

export const AppEnvLozenge = ({ label }: { label?: string }) =>
	label ? <Lozenge appearance={label === 'Dev' ? 'default' : 'moved'}>{label}</Lozenge> : null;
